import { Link } from 'react-router-dom';
import { comics, categories } from '@/mocks/comics';
import ComicCard from '@/components/feature/ComicCard';

function getCategoryName(slug: string): string {
  const cat = categories.find(c => c.slug === slug);
  return cat ? cat.name : slug;
}

export default function LatestSection() {
  const latest = comics.filter(c => c.isNew).slice(0, 6);
  const allComics = comics;

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
              最新上架
            </h2>
            <p className="text-sm text-foreground-500 mt-1">
              第一时间获取最新韩国漫画
            </p>
          </div>
          <Link
            to="/category/all"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        {latest.length > 0 && (
          <div className="mb-8">
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
              {latest.map((comic) => (
                <ComicCard
                  key={comic.id}
                  id={comic.id}
                  title={comic.title}
                  cover={comic.cover}
                  category={comic.category}
                  categoryName={getCategoryName(comic.category)}
                  rating={comic.rating}
                  chapters={comic.chapters}
                  status={comic.status}
                  isHot={comic.isHot}
                  isNew={comic.isNew}
                  views={comic.views}
                />
              ))}
            </div>
          </div>
        )}

        <div className="bg-background-100 rounded-xl p-6 md:p-8">
          <h3 className="text-lg font-bold font-heading text-foreground-900 mb-6">
            热门韩国漫画排行榜
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            {allComics
              .sort((a, b) => b.views - a.views)
              .slice(0, 10)
              .map((comic, idx) => (
                <Link
                  key={comic.id}
                  to={`/comic/${comic.id}`}
                  className="flex items-center gap-4 p-3 rounded-lg hover:bg-background-200 transition-colors group"
                >
                  <span
                    className={`w-7 h-7 flex items-center justify-center rounded-full text-xs font-bold flex-shrink-0 ${
                      idx < 3
                        ? 'bg-primary-500 text-white'
                        : 'bg-background-300 text-foreground-600'
                    }`}
                  >
                    {idx + 1}
                  </span>
                  <div className="flex-1 min-w-0">
                    <h4 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors truncate">
                      {comic.title}
                    </h4>
                    <div className="flex items-center gap-3 text-xs text-foreground-500 mt-0.5">
                      <span>{getCategoryName(comic.category)}</span>
                      <span>共{comic.chapters}话</span>
                      <span className="flex items-center gap-0.5">
                        <i className="ri-star-fill text-[10px] text-accent-500"></i>
                        {comic.rating}
                      </span>
                    </div>
                  </div>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">
                    {(comic.views / 10000).toFixed(0)}万阅读
                  </span>
                </Link>
              ))}
          </div>
        </div>
      </div>
    </section>
  );
}